import { apiClient, unwrap } from './client';
import type { ApiSuccess } from '@/types/api';
import type { CartSummary, AddToCartInput, UpdateCartItemInput } from '@/types/cart';

export const cartApi = {
  async getCart(): Promise<CartSummary> {
    const res = await apiClient.get<ApiSuccess<CartSummary>>('/cart');
    return unwrap(res);
  },

  async addItem(input: AddToCartInput): Promise<CartSummary> {
    const res = await apiClient.post<ApiSuccess<CartSummary>>('/cart', input);
    return unwrap(res);
  },

  async updateItem(cartItemId: number, input: UpdateCartItemInput): Promise<CartSummary> {
    const res = await apiClient.patch<ApiSuccess<CartSummary>>(
      `/cart/${cartItemId}`,
      input
    );
    return unwrap(res);
  },

  async removeItem(cartItemId: number): Promise<CartSummary> {
    const res = await apiClient.delete<ApiSuccess<CartSummary>>(`/cart/${cartItemId}`);
    return unwrap(res);
  },

  async clear(): Promise<CartSummary> {
    const res = await apiClient.delete<ApiSuccess<CartSummary>>('/cart');
    return unwrap(res);
  },

  async applyCoupon(code: string): Promise<CartSummary> {
    const res = await apiClient.post<ApiSuccess<CartSummary>>('/cart/coupon', { code });
    return unwrap(res);
  },
};
